//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region src/net.ts
var net_exports = /* @__PURE__ */ __exportAll({
	CANVAS_CHUNK_SIZE: () => 100,
	CURSOR_FRAME_HEADER_SIZE: () => 8,
	CURSOR_FRAME_KEYFRAME: () => 1,
	CURSOR_FRAME_RECORD_SIZE: () => 24,
	CURSOR_FRAME_VERSION: () => 1,
	CURSOR_MAX_VIEW_REGIONS: () => 16,
	CURSOR_MAX_WORLD_COORDINATE: () => CURSOR_MAX_WORLD_COORDINATE,
	CURSOR_REGION_SIZES: () => CURSOR_REGION_SIZES,
	decodeCursorFrame: () => decodeCursorFrame,
	encodeCursorFrame: () => encodeCursorFrame,
	getCursorRegion: () => getCursorRegion,
	getCursorView: () => getCursorView
});
const CANVAS_CHUNK_SIZE = 100;
const CURSOR_REGION_SIZES = [
	100,
	200,
	400,
	800
];
const CURSOR_MAX_VIEW_REGIONS = 16;
const CURSOR_MAX_WORLD_COORDINATE = 1e6;
const CURSOR_FRAME_VERSION = 1;
const CURSOR_FRAME_HEADER_SIZE = 8;
const CURSOR_FRAME_RECORD_SIZE = 24;
const CURSOR_FRAME_KEYFRAME = 1;
const encodeCursorFrame = (cursors, tick, keyframe = false) => {
	const count = Math.min(cursors.length, 65535);
	const buffer = /* @__PURE__ */ new ArrayBuffer(8 + count * 24);
	const view = new DataView(buffer);
	view.setUint8(0, 1);
	view.setUint8(1, keyframe ? 1 : 0);
	view.setUint16(2, count, true);
	view.setUint32(4, tick >>> 0, true);
	for (let index = 0; index < count; index++) {
		const cursor = cursors[index];
		const offset = 8 + index * 24;
		view.setUint32(offset, cursor[0] >>> 0, true);
		view.setUint32(offset + 4, cursor[1] >>> 0, true);
		view.setInt32(offset + 8, cursor[2], true);
		view.setInt32(offset + 12, cursor[3], true);
		view.setFloat32(offset + 16, cursor[4], true);
		view.setInt32(offset + 20, cursor[5] ?? -1, true);
	}
	return buffer;
};
const decodeCursorFrame = (frame) => {
	if (!(frame instanceof ArrayBuffer) || frame.byteLength < 8) return;
	const view = new DataView(frame);
	if (view.getUint8(0) !== 1) return;
	const count = view.getUint16(2, true);
	if (frame.byteLength !== 8 + count * 24) return;
	const cursors = [];
	for (let index = 0; index < count; index++) {
		const offset = 8 + index * 24;
		const color = view.getInt32(offset + 20, true);
		cursors.push([
			view.getUint32(offset, true),
			view.getUint32(offset + 4, true),
			view.getInt32(offset + 8, true),
			view.getInt32(offset + 12, true),
			view.getFloat32(offset + 16, true),
			color < 0 ? null : color
		]);
	}
	return {
		tick: view.getUint32(4, true),
		keyframe: Boolean(view.getUint8(1) & 1),
		cursors
	};
};
const getCursorRegion = (regionSize, x, y) => ({
	x: Math.floor(x / regionSize),
	y: Math.floor(y / regionSize)
});
const getCursorView = (viewport) => {
	const left = Math.min(viewport.left, viewport.right);
	const right = Math.max(viewport.left, viewport.right);
	const top = Math.min(viewport.top, viewport.bottom);
	const bottom = Math.max(viewport.top, viewport.bottom);
	for (const regionSize of CURSOR_REGION_SIZES) {
		const minRegionX = Math.floor(left / regionSize);
		const maxRegionX = Math.floor(right / regionSize);
		const minRegionY = Math.floor(top / regionSize);
		const maxRegionY = Math.floor(bottom / regionSize);
		if ((maxRegionX - minRegionX + 1) * (maxRegionY - minRegionY + 1) <= 16) return {
			mode: "regions",
			regionSize,
			minRegionX,
			maxRegionX,
			minRegionY,
			maxRegionY
		};
	}
	const regionSize = 800;
	return {
		mode: "regions",
		regionSize,
		minRegionX: Math.floor(left / regionSize),
		maxRegionX: Math.floor(right / regionSize),
		minRegionY: Math.floor(top / regionSize),
		maxRegionY: Math.floor(bottom / regionSize)
	};
};
//#endregion
export { CANVAS_CHUNK_SIZE, CURSOR_FRAME_HEADER_SIZE, CURSOR_FRAME_KEYFRAME, CURSOR_FRAME_RECORD_SIZE, CURSOR_FRAME_VERSION, CURSOR_MAX_VIEW_REGIONS, CURSOR_MAX_WORLD_COORDINATE, CURSOR_REGION_SIZES, decodeCursorFrame, encodeCursorFrame, getCursorRegion, getCursorView, net_exports as t };

//# sourceMappingURL=net.mjs.map